// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.atooltip .ant-tooltip-inner {\r\n\tcolor: #000000 !important;\r\n\tbackground-color: #FFF !important;\r\n\t/* max-width: 500px !important; */\r\n\t/* min-width: 200px !important; */\n}\n.atooltip .ant-tooltip-arrow::before {\r\n\tbackground-color: #FFF !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
